var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "components" },
    [
      _c(
        "a-collapse",
        {
          attrs: {
            defaultActiveKey: _vm.componentKeys,
            bordered: false,
            expandIconPosition: "right",
          },
        },
        _vm._l(_vm.components, function (group) {
          return _c(
            "a-collapse-panel",
            { key: group.key, attrs: { header: group.name } },
            [
              _c(
                "div",
                { staticClass: "module-list" },
                _vm._l(group.data, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "module-item",
                      attrs: { draggable: "true" },
                      on: {
                        click: function ($event) {
                          return _vm.handleClickItem(item.type)
                        },
                        dragstart: function ($event) {
                          return _vm.handleDragStart($event, item.type)
                        },
                        dragend: _vm.handleDragEnd,
                      },
                    },
                    [
                      _c("a-icon", {
                        staticClass: "module-icon",
                        attrs: { component: item.icon },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "module-title" }, [
                        _vm._v(_vm._s(item.name)),
                      ]),
                    ],
                    1
                  )
                }),
                0
              ),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }